import { defineMessages, IntlShape } from "react-intl";

import DistanceUnit from "@mapmycustomers/shared/enum/DistanceUnit";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [DistanceUnit.KM]: {
    id: "distanceUnit.kilometer",
    defaultMessage: "Kilometers",
    description: "Kilometer distance unit",
  },
  [DistanceUnit.MILE]: {
    id: "distanceUnit.mile",
    defaultMessage: "Miles",
    description: "Mile distance unit",
  },
});

const getDistanceUnitDisplayName = (intl: IntlShape, unit: DistanceUnit) =>
  getDisplayName(intl, messages, unit, "DistanceUnit");

export default getDistanceUnitDisplayName;
